export const TESTIMONIALS = [
  {
    quote:
      "The officers don't just turn up — they turn up briefed. Patrol reports land in my inbox before my first coffee, and I can show our insurers exactly what happened on every shift.",
    role: "Facilities Manager",
    sector: "Logistics & Distribution",
    region: "West Midlands",
  },
  {
    quote:
      "They took over a troubled site mid-contract and had it stabilised within a week. Compared to our previous provider, the quality of reporting is night and day.",
    role: "Operations Director",
    sector: "Construction",
    region: "South East England",
  },
  {
    quote:
      "Shrinkage dropped noticeably within the first quarter. The guards are visible, professional, and — just as importantly — our staff genuinely feel safer at work.",
    role: "Area Manager",
    sector: "Retail",
    region: "North West England",
  },
];
